import type { Annotation } from 'api';

import { PhotoEvidenceGallery } from '../PhotoEvidenceGallery/PhotoEvidenceGallery';
import type { PhotoEvidenceItem } from '../PhotoEvidenceList/PhotoEvidenceList';

export type PhotoEvidenceItemVariant = 'success' | 'warning' | 'success-warning' | undefined;

export type EvidenceSessionPhotoGalleryItem = PhotoEvidenceItem & {
  fullResolutionSrc: string;
  annotations?: Annotation[];
  variant?: PhotoEvidenceItemVariant;
};

export const MAX_SESSION_EVIDENCE_PHOTOS = 10;
export const EvidenceSessionPhotoGallery = ({
  photoEvidence,
  maxImages = MAX_SESSION_EVIDENCE_PHOTOS,
  'data-testid': testId,
  handleClick,
}: {
  photoEvidence: EvidenceSessionPhotoGalleryItem[];
  maxImages?: number;
  'data-testid'?: string;
  handleClick?: (photo: PhotoEvidenceItem) => void;
}) => (
  <PhotoEvidenceGallery
    data-testid={testId}
    slotProps={{
      dialogGallery: {
        slotProps: {
          photoList: {
            evidencePhotos: photoEvidence.map((evidence) => ({
              src: evidence.fullResolutionSrc,
              thumbnailSrc: evidence.src,
            })),
          },
        },
      },
      inlineGallery: {
        evidencePhotos: photoEvidence.slice(0, maxImages).map((evidence) => ({
          src: evidence.fullResolutionSrc,
          thumbnailSrc: evidence.src,
        })),
        openOnClick: true,
        slotProps: {
          imageList: {
            cols: maxImages / 2,
          },
        },
      },
    }}
    handleClick={handleClick}
  />
);
